//  fullcalendar版本號v3.9.0
import React, { PureComponent  } from 'react';
import $ from 'jquery';
import moment from 'moment';
import swal from 'sweetalert2';
import 'fullcalendar';
import 'fullcalendar-scheduler';
import 'fullcalendar/dist/locale/zh-tw.js';
import 'fullcalendar/dist/fullcalendar.min.css';
import 'fullcalendar-scheduler/dist/scheduler.min.css';

import '../scss/components/calendar.scss';



class Calendar extends PureComponent  {
  constructor(props) {
    super(props);
    this.state = {
      cal: null,
    }
    this.drawCalendar = this.drawCalendar.bind(this);
    this.handleEventDrop = this.handleEventDrop.bind(this);
    this.handleEventResize = this.handleEventResize.bind(this);
    this.handleEventClick = this.handleEventClick.bind(this);
    this.handleDayClick = this.handleDayClick.bind(this);
    this.handleResourceUpdate = this.handleResourceUpdate.bind(this);
  }
  componentWillUpdate() {

  }
  componentDidMount() {
    let { defaultView, 
      draggable, 
      btnDisplay=true, 
      events = [], 
      resources = [], 
      startTime = null, 
      endTime = null, 
      defaultDate, 
      header,
      handleMonthChange,
      customerButtonFunc, 
      deleteResourceFunc,
      scheduleReRenderFunc, 
      displayEventEnd, 
      finalWorkTimeFunc } = this.props;
    
    $('#calendar').fullCalendar({
      locale: 'zh-tw',
      eventOrder: 'sort',
      timezone: 'Asia/Taipei',
      now: moment(),
      defaultDate: defaultDate ? defaultDate : startTime,
      editable: draggable, // enable draggable events
      aspectRatio: 1.8,
      scrollTime: '08:00', // undo default 6am scrollTime
      slotLabelFormat: "HH:mm",
      header: header,
      eventLimit: 4,
      eventLimitText: "more",
      //resourceOrder: 'jobTypeId',
      customButtons: btnDisplay?{
        promptResource: {
          text: '新增員工',
          click: customerButtonFunc
        },
        printbtn: {
          text: '列印',
          click: function() {
            window.print();
          }
        }
      }:{},
      resourceRender: function(resourceObj, labelTds, bodyTds) {

      },
      eventRender: function(event, element) {
        element.bind('dblclick', function() {
          if (deleteResourceFunc) {
            deleteResourceFunc(event);
          }
        });

        if (event.title.includes('休假') || event.title.includes('例假')) { 
          element.css('background-color', 'lightyellow'); 
        }


        if(event.resourceId === '8'){
          element.css('color', 'white');
          element.css('background-color', 'Crimson');
          element.css('border-color', 'Crimson');
        }else if(event.resourceId === '9'){
          element.css('color', 'black');
          element.css('background-color', 'Gold');
          element.css('border-color', 'Gold');
        }

        var timeElement = element.find('.fc-time');
        if (timeElement.length) {
          if(event.resourceId === '999' ||event.resourceId === '998'||event.resourceId === '997'||event.resourceId === '996'){
            timeElement.removeClass('fc-time');
             timeElement.empty();
            }else{
            var timeText = timeElement.text();
            var timeParts = timeText.split('-');
            if (timeParts.length === 2) {
                timeElement.html(timeParts[0] + '<br>' + timeParts[1]);
            }
            }

        }
        
        var titleElement = element.find('.fc-title'); if (titleElement.length) { 
          var titleText = titleElement.text(); 
          var titleParts = titleText.split('-'); 

          if (titleParts.length === 3) { 
            titleElement.html(titleParts[0] + '<br>' + titleParts[2]);
           } else if (titleParts.length === 2){
            titleElement.html(titleParts[0] + '<br>' + titleParts[1]);

           }
          }
        
      
      },
      viewRender: function(view) {
        if (scheduleReRenderFunc) {
          scheduleReRenderFunc(view.start.format("YYYY-MM-DD"), view.end.format("YYYY-MM-DD"));
        }
        if(handleMonthChange){
          handleMonthChange(view.intervalStart.year(), view.intervalStart.month())
        }
        if (finalWorkTimeFunc) {
          finalWorkTimeFunc(8,view.intervalStart.format("YYYY-MM-DD"), view.intervalEnd.format("YYYY-MM-DD"));
        }
      },
      allDaySlot: false,
      contentHeight:"auto",
      defaultView: defaultView,
      resourceLabelText: '本日工作人員',
      resources: resources,
      events: events,
      schedulerLicenseKey: 'CC-Attribution-NonCommercial-NoDerivatives',
      eventDrop: this.handleEventDrop,
      eventResize: this.handleEventResize,
      eventClick: this.handleEventClick,
      dayClick: this.handleDayClick,
      validRange: {
        start: startTime,
        end: endTime
      },
      businessHours: [
        {
          dow: [ 1, 2, 3, 4, 5 ],
          start: '10:00',
          end: '23:30',
        },
        {
          dow: [ 6, 0 ],
          start: '9:00',
          end: '23:00',
        },
      ],
      minTime: "06:00",
      displayEventEnd: displayEventEnd
    });
  }

  componentDidUpdate() {
    this.drawCalendar();
  }

  // 日曆上的事件被點擊後會觸發的事件
  handleEventClick(event) {    
    // if(event.resourceId != 5){
    //   //alert(`${event.title}\n${moment(event.start).format('hh:mm')}\n${event.end?moment(event.end).format('hh:mm'):''}`);
    //   if(event.resourceId == 3 || event.resourceId == 4|| event.resourceId == 5){
    //     swal(event.title.replace(/(?:\r\n|\r|\n)/g, ''),`${moment(event.start).format('hh:mm')}~\n${event.end?moment(event.end).format('hh:mm'):'未填寫'}`)     
    //   }else{
    //     if (this.props.isEventClick) {          
    //       this.props.eventClick(event);
    //     }else if (this.props.deleteResourceFunc){
    //       this.props.deleteResourceFunc(event);
    //     }       
    //   }

    // }
        if (this.props.isEventClick) {          
          this.props.eventClick(event);
        }else if (this.props.deleteResourceFunc){
          this.props.deleteResourceFunc(event);
        } 
  }

  // 日曆上的日期被點擊後會觸發的事件
  handleDayClick(date) {
    if (this.props.isDayClick) this.props.dayClick(date);
  }

  // 日曆上的事件被拖曳後會觸發的事件 用於調班
  handleEventDrop(event) {
    if (!this.props.draggable) return;
    let data = {
      id: event.id,
      start: event.start.format('YYYY-MM-DD HH:mm:ss'),
      end: event.end.format('YYYY-MM-DD HH:mm:ss'),
      resourceId: 6,
      title: ""
    }
    this.props.editWorkTimeFunc(data);
  }

  // 日曆上的事件時間長短被修改後會觸發的事件 用於調班
  handleEventResize(event) {
    if (!this.props.draggable) return;
    let data = {
      id: event.id,
      start: event.start.format('YYYY-MM-DD HH:mm:ss'),
      end: event.end.format('YYYY-MM-DD HH:mm:ss'),
      resourceId: 6,
      title: ""
    }
    this.props.editWorkTimeFunc(data);
  }

  getCurrentMonth() {
    const currentDate = $('#calendar').fullCalendar('getDate'); // 取得當前顯示的日期
    const currentMonth = currentDate.format('MM'); // 使用 Moment.js 格式化為月份
    return currentMonth;
  }
  // 每次更新event或resource陣列內容時，會重新繪製fullcalendar畫面
  drawCalendar() {
    let { events = [], startTime = null, endTime = null } = this.props;

    this.handleResourceUpdate();
    $('#calendar').fullCalendar('removeEvents');
    $('#calendar').fullCalendar('addEventSource', events);
    if(startTime){
      $('#calendar').fullCalendar('gotoDate', startTime);
    }
    
    if (startTime && endTime) {
      $('#calendar').fullCalendar('option', 'validRange', {
        start: moment(startTime),
        end: moment(endTime).add(1, 'days').format("YYYY-MM-DD HH:mm:ss")
      });
    }
  }

  // 當為調班畫面(view為timelineDay)時，新增工作人員會或減少工作人員會觸發的方法
  handleResourceUpdate() {
    if (!this.state.defaultView === 'timelineDay') return;
    let { resources = [] } = this.props;
    // 獲取舊的resource內容 並更新為新的resource的內容，因為直接props直接更新畫面不會更新，要用fullcallendar提供的方式來更新畫面內容(https://fullcalendar.io/docs/getResources)
    let oldResources = $('#calendar').fullCalendar('getResources');
    oldResources.forEach((oldResource) => {
      if(!resources.some(resource => resource.id === oldResource.id)) {
        $('#calendar').fullCalendar('removeResource', oldResource.id);
      }
    })

    $('#calendar').fullCalendar('removeResource');
    resources.forEach((item) => {
      $('#calendar').fullCalendar('addResource', item);
    });
  }

  render() {
    return (
      <div id="calendar"></div>
    )
  }
}

export default Calendar;